import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";
import { Min } from "../../types/Min";

@Component({
  selector: "app-prefix-gt4",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-gt4.component.html",
  styleUrl: "./prefix-gt4.component.less",
})
export class PrefixGt4Component extends PrefixComponent<string> {
  public max: Max;
  public min: Min;

  public constructor() {
    super({ updateOn: "blur" });
    this.max = 999999999999;
    this.min = 1;
    this.characters = ALLOWED_CHARACTERS["gt4"];
  }
}
